import React, { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { actions } from '../../redux/actions/auth'
import { languageContext } from '../../languageContext'
import textsData from '../../staticTexts'
import { getSvg } from '../../utils/getSvg'
import { version } from '../../utils/version'

const SideMenu = ({
  sidebarStatus,
  active,
  change,
  texts,
  navArray,
  langArray,
  logout,

  selectedEntityIndex,
  allEntities,
}) => {
  //* Getting the selected language by the user
  const { value, setValue } = useContext(languageContext)
  const [staticTexts] = useState(textsData[14])

  const returnAccessRight = (accessRights, right) => {
    let final = false
    accessRights?.map((zone) => {
      if (zone === right) {
        final = true
      }
    })
    return final
  }

  return (
    <div className="fixed inset-0 overflow-hidden">
      <div
        className="z-20 w-full h-full"
        onClick={() => {
          change(!sidebarStatus)
        }}
      ></div>
      <div className="absolute inset-y-0 right-0 z-50 flex max-w-full">
        <div className="flex flex-col w-56 h-full py-6 shadow-xl bg-ecco2blue-100 ">
          <button
            onClick={() => {
              change(!sidebarStatus)
            }}
            className="w-6 h-6 ml-3 text-white rounded-sm fill-current focus:outline-none"
          >
            {getSvg('closeXIcon', '#fff', 24, 24)}
          </button>
          <div className="flex-1 px-6 mt-6">
            {active === 'login' ? null : active === 'home' ||
              active === 'favorites' ? (
              <>
                <div
                  className={`text-white mt-3 mb-3 pl-2 py-2 ${
                    active === 'home'
                      ? 'rounded-md  bg-ecco2blue-200 transform scale-95'
                      : ''
                  }`}
                >
                  <Link
                    onClick={() => {
                      change(false)
                    }}
                    className="flex"
                    to="/home"
                  >
                    {getSvg('buildingsIcon', '#fff', 25, 25)}
                    <div className="ml-3 ">
                      {staticTexts[value].buildingsBtnText}
                    </div>
                  </Link>
                </div>
                <div
                  className={`text-white mt-3 mb-3 pl-2 py-2 ${
                    active === 'favorites'
                      ? 'rounded-md  bg-ecco2blue-200 transform scale-95'
                      : ''
                  }`}
                >
                  <Link
                    onClick={() => {
                      change(false)
                    }}
                    className="flex"
                    to="/favorites"
                  >
                    {getSvg('favoritesIcon', '#fff', 25, 25)}
                    <div className="ml-3 ">
                      {staticTexts[value].favoritesBtnText}
                    </div>
                  </Link>
                </div>
              </>
            ) : (
              <div>
                <div>
                  {navArray[1].map((nav, i) => {
                    if (nav.title === 'apartments') {
                      return allEntities[selectedEntityIndex]?.sensorCount >
                        0 ? (
                        <div
                          key={i}
                          className={`text-white mt-3 mb-3 pl-2 py-2 ${
                            active === nav.title
                              ? 'rounded-md  bg-ecco2blue-200 transform scale-95'
                              : ''
                          }`}
                        >
                          <Link
                            onClick={() => {
                              change(false)
                            }}
                            className="flex"
                            to={`/${nav.title}`}
                          >
                            {getSvg(
                              nav.svgSettings.name,
                              nav.svgSettings.color,
                              nav.svgSettings.width,
                              nav.svgSettings.height,
                            )}
                            <div className="ml-3 ">{texts[`${nav.index}`]}</div>
                          </Link>
                        </div>
                      ) : null
                    } else if (nav.title === 'emr') {
                      return selectedEntityIndex !== '' &&
                        allEntities[selectedEntityIndex]?.EMRs?.length > 0 ? (
                        <div
                          key={i}
                          className={`text-white mt-3 mb-3 pl-2 py-2 ${
                            active === nav.title
                              ? 'rounded-md  bg-ecco2blue-200 transform scale-95'
                              : ''
                          }`}
                        >
                          <Link
                            onClick={() => {
                              change(false)
                            }}
                            className="flex"
                            to={`/${nav.title}`}
                          >
                            {getSvg(
                              nav.svgSettings.name,
                              nav.svgSettings.color,
                              nav.svgSettings.width,
                              nav.svgSettings.height,
                            )}
                            <div className="ml-3 ">{texts[`${nav.index}`]}</div>
                          </Link>
                        </div>
                      ) : null
                    } else if (nav.title === 'temporary-offset') {
                      return selectedEntityIndex !== '' &&
                        returnAccessRight(
                          allEntities[selectedEntityIndex]?.accessRights,
                          'CanChangeOffset',
                        ) === true ? (
                        <div
                          key={i}
                          className={`text-white mt-3 mb-3 pl-2 py-2 ${
                            active === nav.title
                              ? 'rounded-md  bg-ecco2blue-200 transform scale-95'
                              : ''
                          }`}
                        >
                          <Link
                            onClick={() => {
                              change(false)
                            }}
                            className="flex"
                            to={`/${nav.title}`}
                          >
                            {getSvg(
                              nav.svgSettings.name,
                              nav.svgSettings.color,
                              nav.svgSettings.width,
                              nav.svgSettings.height,
                            )}
                            <div className="ml-3 ">{texts[`${nav.index}`]}</div>
                          </Link>
                        </div>
                      ) : null
                    } else {
                      return (
                        <div key={i}>
                          <div
                            className={`text-white mt-3 mb-3 pl-2 py-2 ${
                              active === nav.title
                                ? 'rounded-md  bg-ecco2blue-200 transform scale-95'
                                : ''
                            }`}
                          >
                            <Link
                              onClick={() => {
                                change(false)
                              }}
                              className="flex"
                              to={`/${nav.title}`}
                            >
                              {getSvg(
                                nav.svgSettings.name,
                                nav.svgSettings.color,
                                nav.svgSettings.width,
                                nav.svgSettings.height,
                              )}
                              <div className="ml-3 ">
                                {texts[`${nav.index}`]}
                              </div>
                            </Link>
                          </div>
                          {nav.title === 'favorites' && (
                            <hr className="mt-4 mb-2" />
                          )}
                        </div>
                      )
                    }
                  })}
                </div>
              </div>
            )}

            <hr className="mt-2 mb-2" />
            <div className="mb-1 text-white">{texts.languageText}</div>

            <div className="flex justify-between pl-1 pr-1 ">
              {langArray.map((language, i) => (
                <div
                  onClick={() => {
                    setValue(i + 1)
                    change(false)
                  }}
                  className={`w-min p-2 text-white cursor-pointer  ${
                    value === i + 1
                      ? 'rounded-md bg-ecco2blue-200 transform scale-95'
                      : ''
                  }`}
                  key={i}
                >
                  {texts[`${language}`]}
                </div>
              ))}
            </div>
            <hr className="mt-4 mb-2" />

            {active === 'login' ? null : (
              <div
                onClick={() => {
                  logout()
                  change(false)
                }}
                to="/login"
                className="flex pt-8 text-white cursor-pointer"
              >
                {getSvg('logoutArrowIcon', '#fff', 24, 24)}
                <span className="ml-2">{texts.logoutText}</span>
              </div>
            )}
          </div>
          <span className="mx-auto mb-10 text-white">{version}</span>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  selectedEntityIndex: state.global.selectedEntityIndex,
  allEntities: state.global.allEntities,
})

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(actions.logOut()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SideMenu))
